import { store } from '../store';
import MicroModal from 'micromodal';
import {createApp} from 'vue';

// Header functions


var lastScrollTop = 0;
window.addEventListener(
	"scroll",
	function () {
		var st = window.pageYOffset || document.documentElement.scrollTop;
		let headerNavbar = document.querySelector(".c-header__desktop");
		if (headerNavbar) {
			if (st > lastScrollTop) {
				if (document.documentElement.scrollTop > 220) {
					headerNavbar.classList.add("scrolled");
				}
			} else {
				if (document.documentElement.scrollTop < 220) {
					if (headerNavbar.classList.contains("scrolled")) {
						headerNavbar.classList.remove("scrolled");
					}
				}
			}
			lastScrollTop = st <= 0 ? 0 : st;	
		}
	},
	false
);

var subMenuToggleMenus = Array(document.querySelectorAll('.c-header__main-navigation .mega-submenu-toggle'))[0];
subMenuToggleMenus.forEach(item=>{
	let linkBtn = item.querySelector('a');

	let parentItem = item.closest('.mega-submenu-toggle');
	let parentContainer = item.closest('.mega-sub-menu');
	let menuContainer = item.querySelector('.mega-sub-menu');
	let megaMenuRow = item.closest('.mega-menu-row');

	linkBtn.addEventListener('click', (e)=>{
		if (window.innerWidth < 1200) {
			e.preventDefault();
			let parentItem = item.closest('.mega-submenu-toggle');
			let parentContainer = item.closest('.mega-sub-menu');
			parentItem.classList.add('selected');
		}
		
	});


	//var mouseInEl = false;
	item.addEventListener('mouseenter', (e)=>{
		e.preventDefault();
		if (window.innerWidth >= 1200) {
			let parentItem = item.closest('.mega-submenu-toggle');
			let parentContainer = item.closest('.mega-sub-menu');
			
			parentItem.classList.add('selected');
			let desiredHeight = (menuContainer.clientHeight + 5).toString() + 'px';
			if (megaMenuRow.clientHeight < menuContainer.clientHeight) {
				megaMenuRow.style.height = desiredHeight;
			}
			
			/* console.log('Entramos a ' + e.target.id);
			console.log('Status: ' + mouseInEl);
			setTimeout(()=>{
				if (mouseInEl) {
					console.log('Abrimos ' + e.target.id);
					console.log('Status: ' + mouseInEl);
					parentItem.classList.add('selected');
					let desiredHeight = (menuContainer.clientHeight + 5).toString() + 'px';
					if (megaMenuRow.clientHeight < menuContainer.clientHeight) {
						megaMenuRow.style.height = desiredHeight;
					}
				}
			},280) */


		}
	});
	/* item.addEventListener('mouseenter', (e)=>{
		mouseInEl = true;
	});
	item.addEventListener('mouseleave', (e)=>{
		mouseInEl = false;
	}); */

	item.addEventListener('mouseleave', (e)=>{
		e.preventDefault();
		if (window.innerWidth >= 1200) {
			let parentItem = item.closest('.mega-submenu-toggle');
			let parentContainer = item.closest('.mega-sub-menu');
			parentItem.classList.remove('selected');
			megaMenuRow.style.height = 'auto';
			/* mouseInEl = false;
			console.log('Salimos de ' + e.target.id);
			console.log('Status: ' + mouseInEl);
			setTimeout(()=>{
				console.log('Cerramos ' + e.target.id);
				console.log('Status: ' + mouseInEl);
				parentItem.classList.remove('selected');
				megaMenuRow.style.height = 'auto';
			},280) */
			
		}
	}); 

	let element = document.createRange().createContextualFragment('<li class="mega-menu-item return-item"><a href="#" class="return-btn"><span class="icon-back"></span><span class="link-text">' + linkBtn.innerHTML + '</span></a></li>');
	menuContainer.insertBefore(element, menuContainer.firstChild);
	let returnBtn = menuContainer.querySelector('.return-btn');
	returnBtn.addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		parentItem.classList.remove('selected');
	})
	let elementCloseMenu = document.createRange().createContextualFragment('<li class="item-close-menu"><a href="#"><span class="icon-close"></span></a></li>');
	menuContainer.insertBefore(elementCloseMenu, menuContainer.firstChild);
	menuContainer.querySelector('.item-close-menu').addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		closeMobileMenu();
	});
});

function closeMobileMenu(){
	let menuModal = document.querySelector('.c-header__main-navigation .mega-menu-toggle');
	let menuItems = Array(document.querySelectorAll('.c-header__main-navigation .mega-toggle-on'))[0];
	let subMenuItems = Array(document.querySelectorAll('.c-header__main-navigation .selected'))[0];

	menuModal.classList.remove('mega-menu-open');
	menuItems.forEach(item => {
		item.classList.remove('mega-toggle-on');
	});
	subMenuItems.forEach(item => {
		item.classList.remove('selected');
	})
}

var returnSubMenuToggles = Array(document.querySelectorAll('.c-header__main-navigation .mega-mobile-return-item'))[0];
returnSubMenuToggles.forEach(item => {
	let parentItem = item.parentElement.closest('.mega-menu-item');
	let trigger = item.querySelector('a');
	trigger.addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		parentItem.classList.remove('mega-toggle-on');
	})
	let elementCloseMenu = document.createRange().createContextualFragment('<li class="item-close-menu"><a href="#"><span class="icon-close"></span></a></li>');
	item.parentElement.insertBefore(elementCloseMenu, item.parentElement.firstChild);
	item.parentElement.querySelector('.item-close-menu').addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		closeMobileMenu();
	});

});

var mobileSearchToggle = Array(document.querySelectorAll('[data-trigger="mobile-search-toggle"]'))[0];
mobileSearchToggle.forEach(item => {
	item.addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		item.closest('.c-header__mobile-search-item').classList.add('open');
	});
});

var mobileSearchClose = Array(document.querySelectorAll('[data-trigger="mobile-search-close"]'))[0];
mobileSearchClose.forEach(item => {
	item.addEventListener('click', (e)=>{
		e.preventDefault();
		e.stopPropagation();
		item.closest('.c-header__mobile-search-item').classList.remove('open');
	});
});
  
function callback(mutationList, observer) {
mutationList.forEach(function(mutation) {
	if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
		if (mutation.target.querySelectorAll('.active')) {
			let arr = Array(mutation.target.querySelectorAll('.active'))[0];
			arr.forEach(arr_item=>{
				arr_item.classList.remove('active');
			})
		}
		if (mutation.target.querySelectorAll('.selected')) {
			let arr = Array(mutation.target.querySelectorAll('.selected'))[0];
			arr.forEach(arr_item=>{
				arr_item.classList.remove('selected');
			})
		}
	}
})
}

var headerMenuMainItems = Array(document.querySelectorAll('#mega-menu-menu-header > .mega-menu-item'))[0]
headerMenuMainItems.forEach(item => {
	var observer = new MutationObserver(callback)
	observer.observe(item, {
		attributes: true
	})
});


// --> Recover the Bearer token if needed
function getBearerToken(func, petition_url, executeFunc){
	let request = new XMLHttpRequest();
	let url = '/wp-content/themes/cateb/src/services/auth/getBearer.php';
	let responseQuality = true;
	request.open('GET', url);
	request.onload = () => {
		let data;		
		try 
			{ data = JSON.parse(request.response); }
		catch (e) 
			{ responseQuality = false; }
		if (responseQuality) {
			if (func) {
				func(petition_url, executeFunc);
			}
		}else{
			console.log('ERROR!')
		}
	}
	request.send();
}

// --> Modular petition function. Gets a url to call to and a function to call in case of success.
var errorLoop = 0;
export function sendPetition(url, executeFunc){
	let request = new XMLHttpRequest();
	let responseQuality = true;
	request.open('GET', url);
	request.onload = () => {
		let data;
		try 
			{ data = JSON.parse(request.response); }
		catch (e) 
			{ responseQuality = false; }
		if (responseQuality) {
			//console.log(data);
			if (data[0]) {
				if(data[0].errorCode && data.find(item=>(item.errorCode === "INVALID_SESSION_ID"))){
					console.log('error: Invalid credentials');
					if (errorLoop<3) {
						getBearerToken(sendPetition, url, executeFunc);
						errorLoop++;
					}
				}else{
					//console.log(data)
					console.log('error')
				}
			}else{
				if(data.result){
					//console.log(data.result)
					if (data.result.statusCode) {
						if (data.result.statusCode==200) {
							errorLoop = 0;
							executeFunc(data);
						}else if(data.result.statusCode==401 && url.search()!="login.php"){
							errorLoop = 0;
							executeFunc(data);
						}else if(data.result.statusCode==500 && url.search()!="login.php"){
							errorLoop = 0;
							executeFunc(data);
						}else{
							errorLoop = 0;
							console.log('error');
							//console.log(data)
							//console.log(url)
							if (url.includes('checkout')) {
								executeFunc(data);
							}
							if (url.includes('technicalRequest')) {
								executeFunc(data);
							}
						}
					}else{
						//console.log(data)
						console.log('error');
					}
				}else{
					if (url.includes('checkout')) {
						errorLoop = 0;
						executeFunc(data);
					}
				}
			}
		}else{
			//console.log(request.response)
			console.log('error');
			if (url.includes('technicalRequest')) {
				executeFunc(data);
			}
		}
	}
	request.send();
}

function getColegiats(funcData){
	let url = '/wp-content/themes/cateb/src/services/collegiats/getCollegiats.php'
		+"?firstname="+funcData.firstname
		+"&lastname="+funcData.lastname
		+"&city="+funcData.city
		+"&postalcode="+funcData.postalcode
		+"&comarca="+funcData.comarca
		+"&birthdate="+funcData.birthdate
		+"&document="+funcData.document;
	store.dispatch('collegiats/loadCollegiats', url);
}

function getList(funcData){
	let url = '/wp-content/themes/cateb/src/services/lists/getLists.php'
		+"?list_id="+funcData.id
	store.dispatch('professionals/loadProfessionals', url);
}

if(document.querySelector('.vue-exclusive-post')){
	var app_courses_module = createApp({
		data(){
			return {
				sessionOpen: false
				
			}
		},
		computed: {
			clientLogged(){
				return store.getters['account/clientLogged']
			},
		},
		watch:{
			clientLogged: function(){
				if (this.clientLogged || sessionStorage.getItem('loginStatus')) {
					this.sessionOpen = true;
				}
			},
		},
		mounted(){
			console.log('initializing exclusive page');
			//this.sessionOpen = false;
			/* console.log(this.clientLogged)
			console.log(sessionStorage.getItem('loginStatus'))
			console.log(this.sessionOpen) */
			if (this.clientLogged || sessionStorage.getItem('loginStatus')) {
				this.sessionOpen = true;
			}
		},
		methods:{
			
		}
	}).mount(document.querySelector('.vue-exclusive-page'));
} 


window.onload = function(){
    MicroModal.init();
}
